<app-card-box>
  <div class="g-card-box" header>
    <div class="g-card-box-row">
      <div class="g-card-box-title">
        {{ projectFilesTexts.title }}
      </div>
      <app-upload-file
        #projectFilesUpload
        hidden
        (change)="onFileChanged(projectFilesUpload)"
        [appMaxFileSizeValidator]="50"
        [formControl]="fileControl"
        maxUnitType="MB"
        accept=".l5x, .l5k"
        [appId]="AppIdsEnum.upload_project_files_button"
      >
      </app-upload-file>

      <div>
        <app-ui-button [size]="'small'" [label]="generalTexts.buttons.upload"
                       [capability]="Capability.WriteUpdates"
                       (clicked)="openFileUploadDialog()" [isLoadingState]="isLoading">
        </app-ui-button>
      </div>
    </div>

    <div class="g-card-box-sub-title g-margin-top-15">
      <p>{{ projectFilesTexts.description }}</p>
    </div>
  </div>
</app-card-box>
